import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';
import { createRouteNodeSelector } from 'redux-router5';

import PaycodeListHeader from '../../components/codes/PaycodeListHeader';

import { getPaycodeFilter, paycodeFilterParams } from '../../services/qsfilters';
import { setPaycodeCurrentPage } from '~/apps/sender/actions/paycodes';


class PaycodeHeader extends React.Component<any, any> {
  render() {
    const { route: { params }, dispatch } = this.props;
    const filter = getPaycodeFilter(params);

    return (
      <PaycodeListHeader
        onFilter={(q) => {
          filter.q = q;
          navigate('sender.paycodes', paycodeFilterParams(filter));
          dispatch(setPaycodeCurrentPage(0));
        }}
        filter={filter}
        onCreate={() => navigate('sender.paycodes.create')} />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(createRouteNodeSelector('receiver.admin.transactions'), mapDispatchToProps)(PaycodeHeader) as any;
